<template>
  <lm-modal
    :ref="modalName"
    :name="modalName"
    class="ModalMentionList"
    title="Insights Evaluation Matrix"
    disable-tabindex
    remove-footer
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <insight-matrix-preview />
  </lm-modal>
</template>

<script>
import {Events, Modal} from '@/lib/definitions'
import LmModal from '@/components/ui/LmModal'
import InsightMatrixPreview from '@/components/landscape/insights/matrix/InisghtMatrixPreview'

export default {
  name: 'ModalMatrixPreview',
  components: {
    LmModal,
    InsightMatrixPreview
  },
  data() {
    return {
      modalName: Modal.MATRIX_PREVIEW,
      Events
    }
  },
  created() {},
  methods: {
    modalClosed() {}
  }
}
</script>
